module.exports = __webpack_public_path__ + "img/galeria-florestal-3.dfcdf28e.jpg";